/**
 * src/lib/cifras.js
 * Cómo se escribe un número en el panel. Un solo sitio.
 *
 * Estaba copiado tres veces —`clp` en TiendasDelTenant y en Ejecuciones, `_fmt`
 * en ClienteDetalle— y las tres copias hacían ya cosas distintas ante un nulo.
 * Es el §4 de docs/ERRORES_RECURRENTES.md: la misma regla en varios sitios
 * empieza igual y termina discrepando.
 *
 * ⚠️ El nulo SIEMPRE es «—», nunca 0 (§3). Está aquí, en la única función que
 * pinta cifras, para que no haya que acordarse en cada pantalla.
 */

/** Un número con separador de miles chileno. `null` → «—». */
export function num(v) {
  return (v === null || v === undefined) ? '—' : Number(v).toLocaleString('es-CL')
}

/** Un importe en pesos. `null` → «—», nunca «$0». */
export function clp(v) {
  return (v === null || v === undefined) ? '—' : `$${Number(v).toLocaleString('es-CL')}`
}

/**
 * Un porcentaje sobre un total, redondeado. Devuelve `null` —no 0— cuando no
 * se puede calcular: sin total no hay porcentaje, y un «0 %» ahí sería una
 * afirmación que nadie ha medido.
 */
export function pct(parte, total) {
  if (parte === null || parte === undefined) return null
  if (!total) return null
  return Math.round((Number(parte) / Number(total)) * 100)
}
